export const campaignDashboardHeaders: { key: string; value: string }[] = [
  {
    key: 'Campaign Name',
    value: 'Campaign Name',
  },
  {
    key: 'ID',
    value: 'ID',
  },
  {
    key: 'Status',
    value: 'Status',
  },
  {
    key: 'App IDs',
    value: 'App IDs',
  },
  {
    key: 'Start Date/Time',
    value: 'Start\nDate/Time',
  },
  {
    key: 'End  Date/Time',
    value: 'End\nDate/Time',
  },
  {
    key: 'Display Type',
    value: 'Display\nType',
  },
  {
    key: 'URL Patterns',
    value: 'URL\nPatterns',
  },
  {
    key: 'Search Terms',
    value: 'Search\nTerms',
  },
  {
    key: 'Actions',
    value: 'Actions',
  },
];
